// extracted by mini-css-extract-plugin
module.exports =  {"container":"_33974c2b58--container--Wi_z0","icon":"_33974c2b58--icon--MqPVY"};